// extracted by mini-css-extract-plugin
module.exports = {"createNewPage":"newSlideModal_createNewPage__ISF0V","item":"newSlideModal_item__2hXf9","grid":"newSlideModal_grid__ErObY"};